// Lib
import React from 'react';
import { Box } from '@mui/material';

// Components
import RemovedProduct from './RemovedProduct';
import { Typography } from '@mui/material';
import Button from '../../Button';

// Hooks
import useModal from '../../../hooks/useModal';
import { useSelector } from 'react-redux';

// Selectors
import { productsObjSelector } from '../../../store/selectors';

// Styles
import { useStyles } from './RemovedProductsStyles';

const RemovedProducts = ({ products }) => {
  const { classes } = useStyles();
  const { onClose } = useModal();
  const single = products?.length === 1;
  const productsObj = useSelector((state) => productsObjSelector(state));

  return (
    <div className={classes.removedProductsContainer}>
      <Typography
        variant="h2"
        className={classes.title}
        data-testid="removed-products-header">
        {single
          ? 'This product has been removed from the site.'
          : 'These products have been removed from the site.'}
      </Typography>
      <Box className={classes.scrollArea}>
        {products?.map(({ product }) => {
          return (
            <RemovedProduct key={product} product={productsObj?.[product]} />
          );
        })}
      </Box>
      <Box className={classes.modalFooter}>
        <Button className={classes.button} onClick={onClose}>
          Close
        </Button>
      </Box>
    </div>
  );
};

export default RemovedProducts;
